import React from 'react';

const AnchorProperties = ({ block, onUpdate }) => {
    return (
        <div>
            <label className="block text-sm font-medium">Nom de l'ancre</label>
            <input 
                type="text" 
                value={block.content} 
                onChange={(e) => onUpdate(block.id, { content: e.target.value })} 
                className="w-full p-2 border rounded mt-1" 
                placeholder="ex: programme"
            />
        </div>
    );
};

export default AnchorProperties;